import { IAdminInsightsResult } from '../types/IAdminInsightsResult';
import { Request } from './Request';

export class AdminInsightsCreateProjectRequest
    extends Request<{}, IAdminInsightsResult> {

    constructor() {
        super('enableAdminInsights', {});
    }
}
